/**
 * PATH: apps/qa/src/components/inspection/FloorBuilder/constants.ts
 * PURPOSE: Floor type styling and helpers for FloorBuilder
 */

import { Home, ArrowUp, ArrowDown, Layers } from 'lucide-react'
import type { FloorType } from './types'

export const FLOOR_TYPE_STYLES: Record<FloorType, { bg: string; border: string; text: string; icon: typeof Home }> = {
  basement: {
    bg: 'bg-blue-500/20 dark:bg-blue-500/30',
    border: 'border-blue-500/50',
    text: 'text-blue-700 dark:text-blue-300',
    icon: ArrowDown,
  },
  ground: {
    bg: 'bg-emerald-500/20 dark:bg-emerald-500/30',
    border: 'border-emerald-500/50',
    text: 'text-emerald-700 dark:text-emerald-300',
    icon: Home,
  },
  standard: {
    bg: 'bg-slate-100 dark:bg-slate-800',
    border: 'border-slate-200 dark:border-slate-700',
    text: 'text-slate-700 dark:text-slate-300',
    icon: Layers,
  },
  rooftop: {
    bg: 'bg-amber-500/20 dark:bg-amber-500/30',
    border: 'border-amber-500/50',
    text: 'text-amber-700 dark:text-amber-300',
    icon: ArrowUp,
  },
}

export const generateId = () => Math.random().toString(36).substr(2, 9)

export const generateAreaCode = (floorName: string, areaName: string): string => {
  const floorPart = floorName.replace(/[^a-zA-Z0-9]/g, '').substring(0, 2).toUpperCase()
  const areaPart = areaName.replace(/[^a-zA-Z0-9]/g, '').substring(0, 3).toUpperCase()
  return `${floorPart}-${areaPart}`
}
